import { Component, OnInit } from '@angular/core';
import { LeaveService } from '../services/leave.service'
import { UserService } from '../services/user.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { endOfMonth } from 'date-fns';
import { NzMessageService } from 'ng-zorro-antd/message';
@Component({
  selector: 'app-leave',
  templateUrl: './leave.component.html',
  styleUrls: ['./leave.component.less']
})
export class LeaveComponent implements OnInit {
  loading = true;
  perPage = 10;
  page = 1;
  total:string;
  leaveData:any=[];
  isVisible:any;
  getFullYear: number = new Date().getFullYear();
  userId:string;
  reasonDetail:string;
  userData:any=[];
  createModal = false;
  validateForm!: FormGroup;
  pageIndex: number;
  isCollapsed = false;
  ranges = { Today: [new Date(), new Date()], 'This Month': [new Date(), endOfMonth(new Date())] };
  constructor(
    private leaveService: LeaveService,
    private userService:UserService,
    private fb: FormBuilder,
    private message: NzMessageService
  ) { }

  ngOnInit() {
    this.getLeave();
    this.getUser();
    this.validateForm = this.fb.group({
      reason: [null, [Validators.required]],
      reasonDetail:[null],
      dayoffwork: [null, [Validators.required]]
    });
  }
  onChange(result: Date[]): void {
  }

  

  getLeave(){
    this.pageIndex = 1;
    this.leaveService.getAll(this.perPage, this.page).subscribe((res:any)=>{
      this.loading = false;
      this.total = res.data.total;
      this.leaveData = res.data.data;
    });
  }
  getUser(){
    this.userService.getProfile().subscribe((res:any)=>{
      this.userId = res.data._id;
      this.userData = res.data.employee;          
    });
  }
  showModal(id:string): void {
    this.isVisible = id ;
  }
  handleCancel(): void {
    this.isVisible = false;
    this.createModal = false;
  }
  handleOk(): void {
    this.isVisible = false;
    this.createModal = false;
  }
  cancelRequest(id:string): void {
    this.leaveService.deleteRequest(id).subscribe((res:any)=>{
      if(res.message=="Success"){
        this.handleCancel();
        this.getLeave();
      }
    });
  }
  submitForm(reason:any, dayoff:any): void {
    
    const content = {
      "reason": reason,
      "start_at": dayoff[0].nativeDate,
      "end_at": dayoff[1].nativeDate
    }

    this.leaveService.postRequest(content).subscribe((res:any)=>{
      if(res.message=="Success"){
        this.message.success('Tạo thành công đơn xin nghỉ phép!', {
          nzDuration: 2500
        });
        this.handleCancel();
        this.getLeave();
      }
    })
  }
  onPageIndexChange($event:any) {
    this.leaveService.getAll(this.perPage, $event).subscribe((res:any)=>{
      this.loading = false;
      this.total = res.data.total;
      this.leaveData = res.data.data;
    });
  }
}
